import { CognitoLoginController } from './CognitoLoginController';

export const Login = () => {
  return <CognitoLoginController />;
};
